export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14481.2976e998.jpg";